import { Component, ElementRef, Injectable, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { IvrService } from '../../../../../../common/services/Ivr.service';
import { IvrgatewayService } from '../../../../../../common/services/Ivrgateway.service';
import { BsModalService } from 'ngx-bootstrap';
import { UploadService } from '../../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../../common/services/Common.service';
import { IvrTab } from './ivr.const';
import { NavigationEnd, Router } from '@angular/router';
import { getCurrentTab } from './ivr.const';

declare var $: any;

@Component({
  selector: 'settings-switchboard-ivr',
  templateUrl: './ivr.component.html',
  styleUrls: ['./ivr.component.css', '../switchboard.component.css'],
  providers: [IvrService, BsModalService, UploadService, CommonService, IvrgatewayService],
})
@Injectable()
export class IvrComponent implements OnInit {
  public currentTab;
  public tabList = [
    { id: IvrTab.scenario, title: 'Kịch bản' },
    { id: IvrTab.audio, title: 'File ghi âm' },
  ];
  protected readonly IvrTab = IvrTab;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }

  onChangeTab(id) {
    this.currentTab = id;
    this.router.navigate([id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/ivr.component.ts